import { BaseService } from '@services/BaseService';
import { OptionsViewModel, PageViewModel } from '@models/common.models';
import { TerritoryViewModel } from '@models/Territory';

class RealEstateService extends BaseService {
  constructor() {
    super('realEstate');
  }

  getTerritories(q?: string, id?: number) {
    return this.fetch<PageViewModel<TerritoryViewModel>>('Territories', {
      method: 'POST',
      body: JSON.stringify({
        id: id,
        query: q || '',
        page: 1,
        pageSize: 500
      })
    });
  }

  getEOCarriers() {
    return this.fetch<OptionsViewModel[]>('EOCarriers', {
      method: 'GET'
    });
  }
}

export const realEstateService = new RealEstateService();



// WEBPACK FOOTER //
// ./src/_services/RealEstateService.ts